import { useParams } from 'react-router-dom';
import { loadStripe } from '@stripe/stripe-js';
import { Elements } from '@stripe/react-stripe-js';
import BackButton from '@/components/common/BackButton';
import Page from '@/components/layout/Page';
import HorizontalLogo from '@/components/common/HorizontalLogo';
import { useCart } from '@/data/cart';
import Loader from '@/components/common/Loader';
import PaymentConfirmation from './PaymentConfirmation';

const stripePromise = loadStripe(
  import.meta.env.VITE_STRIPE_PUBLISHABLE_API_KEY
);

const PaymentConfirmationPage = () => {
  const { cartId } = useParams();
  const cart = useCart(cartId);

  if (cart.isLoading && !cart.data) {
    return (
      <Page>
        <BackButton />
        <div className="p-8">
          <HorizontalLogo />
        </div>
        <div className="flex justify-center items-center h-[calc(100vh-320px)]">
          <Loader />
        </div>
      </Page>
    );
  }

  return (
    <Page>
      <BackButton />
      <div className="p-8">
        <HorizontalLogo />
      </div>
      <Elements stripe={stripePromise}>
        <PaymentConfirmation />
      </Elements>
    </Page>
  );
};

export default PaymentConfirmationPage;
